import { render, staticRenderFns } from "./VasAddress.vue?vue&type=template&id=38755ee6&scoped=true&"
import script from "./VasAddress.vue?vue&type=script&lang=ts&"
export * from "./VasAddress.vue?vue&type=script&lang=ts&"
import style0 from "./VasAddress.vue?vue&type=style&index=0&id=38755ee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38755ee6",
  null
  
)

export default component.exports